import React from 'react';
import { useSelector } from 'react-redux';
import { Form, Button } from 'react-bootstrap';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';
import VehiculosTable from '../../components/Directorio/Vehiculos/VehiculosTable';
import VehiculoDetalleModal from '../../components/Directorio/Vehiculos/VehiculoDetalleModal';
import { useVehiculosMantenedor } from '../../hooks/useVehiculosMantenedor';
import * as FaIcons from 'react-icons/fa';

const VehiculosPage = () => {
  const user = useSelector(state => state.auth.user);
  const { userPermissions } = useMantenedores();
  const permisos = userPermissions?.modules?.directorio || {};
  
  const {
    vehiculos,
    total,
    loading,
    error,
    tipos,
    tiposLoading,
    pageNumber,
    pageSize,
    searchValue,
    tipoVehiculoId,
    selectedVehiculo,
    vehiculoDetalle,
    detalleLoading,
    showModal,
    modalMode,
    handleSearchChange,
    handleTipoVehiculoChange,
    handlePageChange,
    handlePageSizeChange,
    handleCreateVehiculo,
    handleEditVehiculo,
    handleDeleteVehiculo,
    handleOpenCreateModal,
    handleOpenEditModal,
    handleCloseModal,
    fetchVehiculoDetalle
  } = useVehiculosMantenedor(user, permisos);

  const columns = [
    { Header: 'PPU', accessor: 'ppu', id: 'ppu' },
    { Header: 'Tipo', accessor: row => row.tipo_vehiculo?.tipo || '-', id: 'tipo' },
    { Header: 'Conductores', accessor: 'usuarios_moviles_count', id: 'usuarios_moviles_count' }
  ];

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <SimpleMantenedorLayout
      mantenedorId="directorio"
      title="Gestión de Vehículos"
      subtitle="Administración de vehículos y flota de transporte"
      iconColor="#28a745"
      showBackButton={false}
      breadcrumbs={[
        {
          label: 'Directorio',
          path: '/mantenedores/directorio'
        },
        {
          label: 'Vehículos'
        }
      ]}
    >
      {error && (
        <div className="alert alert-danger mb-3">
          {error}
        </div>
      )}

      <div className="mb-3 d-flex gap-2 align-items-center justify-content-between">
        <div className="d-flex gap-2">
          <Form.Select 
            style={{ width: 220 }} 
            value={tipoVehiculoId || ''} 
            onChange={e => handleTipoVehiculoChange(e.target.value || null)}
            disabled={tiposLoading}
          >
            <option value="">Todos los tipos</option>
            {tipos.map(tipo => (
              <option key={tipo.id} value={tipo.id}>{tipo.tipo}</option>
            ))}
          </Form.Select>

          <Form.Control 
            type="text" 
            placeholder="Buscar PPU (mín. 3 caracteres)" 
            style={{ width: 320 }} 
            value={searchValue} 
            onChange={e => handleSearchChange(e.target.value)}
          />
        </div>

        {permisos.canCreate && (
          <Button
            variant="primary"
            onClick={handleOpenCreateModal}
            className="d-flex align-items-center gap-2"
          >
            <FaIcons.FaPlus />
            Nuevo Vehículo
          </Button>
        )}
      </div>

      <VehiculosTable
        columns={columns}
        data={vehiculos}
        pageCount={totalPages}
        pageIndex={pageNumber - 1}
        onPageChange={page => handlePageChange(page + 1)}
        pageSize={pageSize}
        onPageSizeChange={handlePageSizeChange}
        onRowClick={fetchVehiculoDetalle}
        loading={loading}
        total={total}
        onEditClick={handleOpenEditModal}
        onDeleteClick={handleDeleteVehiculo}
        permisos={permisos}
      />

      <VehiculoDetalleModal
        show={showModal}
        onHide={handleCloseModal}
        vehiculo={vehiculoDetalle}
        loading={detalleLoading}
        mode={modalMode}
        onSave={modalMode === 'create' ? handleCreateVehiculo : handleEditVehiculo}
        tipos={tipos}
        permisos={permisos}
      />
    </SimpleMantenedorLayout>
  );
};

export default VehiculosPage;
